export default __webpack_public_path__ + "static/media/odeh.64f499e8.png";